<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoShare' :class="{scrollHide: isShowStoreBox}">
    <div class="showBox" v-if="!isSearchLoading">
      <div class="" v-if="dataInfo.is_del==='1'">
        <div class="card">
          <div class="card-body">
            <p class="card-text content">注：将通知数据创建人</p>
            <a href="javascript:void(0);" @click="modifyBoxFun(9)" class="btn btn-warning btn-round btn-block">转机会（捞出回收站）</a>
          </div>
        </div>
      </div>
      <div class="card" v-if="dataInfo.type!=='1' && dataInfo.is_del!=='1'">
        <div class="card-body">
          <p v-if="dataInfo.duty_users" class="card-text content" style="margin-bottom: 0.5em;">
            <button v-for="(app,index) in duty_users_arr" :key="index" style="margin-bottom:5px;margin-right:5px;border-radius:15px;" class="btn btn-outline-secondary btn-sm" disabled>
              {{app}}
            </button >
          </p>
          <p v-else class="content" style="margin-bottom: 0.5em;">
            该数据未共享人任何同事...
          </p>
          <p class="card-text content">注：修改将通知受影响的同事</p>
          <a v-if="(dataInfo.type==='2' && rbacCrmsethopeshare) || (dataInfo.type==='3' && rbacCrmsetsignshare)" href="javascript:void(0);" @click="modifyBoxFun(1)" class="btn btn-primary btn-round">
            &nbsp;&nbsp;&nbsp;共享人&nbsp;&nbsp;&nbsp;
          </a>
          <span class="btn btn-light btn-round text-muted" disabled v-else>&nbsp;&nbsp;&nbsp;共享人&nbsp;&nbsp;&nbsp;</span>
        </div>
      </div>
      <div class="towBox" v-if="dataInfo.is_del!=='1'">
        <div class="card" v-if="dataInfo.type==1">
          <div class="card-body">
            <p class="card-text content">注：将通知创建人及新负责人</p>
            <a href="javascript:void(0);" @click="modifyBoxFun(8)" class="btn btn-warning btn-round btn-block">转意向</a>
          </div>
        </div>
        <div class="card" v-if="dataInfo.type==2 || dataInfo.type==3">
          <div class="card-body">
            <p class="card-text content">注：将通知原/新负责人</p>
            <a v-if="(dataInfo.type==='2' && rbacCrmsethopeduty_uid) || (dataInfo.type==='3' && rbacCrmsetsignduty_uid)" href="javascript:void(0);" @click="modifyBoxFun(2)" class="btn btn-primary btn-round btn-block">负责人</a>
            <span class="btn btn-light btn-round text-muted btn-round btn-block" disabled v-else>负责人</span>
          </div>
        </div>
        <div class="card" v-if="dataInfo.type==2">
          <div class="card-body">
            <p class="card-text content">将通知负责/共享/创建人</p>
            <a href="javascript:void(0);" @click="modifyBoxFun(3)" class="btn btn-warning btn-round btn-block">转机会</a>
          </div>
        </div>
        <div class="card" v-if="dataInfo.type==2">
          <div class="card-body">
            <p class="card-text content">原/新负责人&共享/创建人</p>
            <a href="javascript:void(0);" @click="modifyBoxFun(4)" class="btn btn-warning btn-round btn-block">转客户</a>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <p class="card-text content">注：将通知负责/创建/共享人</p>
            <a v-if="(dataInfo.type==='1' && rbacCrmsetchancedel) || (dataInfo.type==='2' && rbacCrmsethopedel) || (dataInfo.type==='3' && rbacCrmsetsigndel)" href="javascript:void(0);" @click="submitFun(5)" class="btn btn-danger btn-round btn-block">
              <i v-if="isSubmitLoading && type===5" class='iconfont icon-jiazai xuanzhuan'></i> 删除客户
            </a>
            <span class="btn btn-light btn-round text-muted btn-round btn-block" disabled v-else>删除客户</span>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div v-if="dataInfo.is_black && dataInfo.is_black.is_state==='1'" class="card-text content">
              <span class="text-danger">黑名单</span>中检索到相似的数据
              <hr class="mt-2 mb-2">
              电话/微信/邮箱
            </div>
            <div v-if="dataInfo.is_black && dataInfo.is_black.is_state==='0'" class="card-text content">
              检测倒<span class="text-danger">审核中</span>的黑名单
              <hr class="mt-2 mb-2">
              电话/微信/邮箱
            </div>
            <p v-if="!dataInfo.is_black" class="card-text content">注：审核后通知提交人</p>
            <a v-if="!dataInfo.is_black" href="javascript:void(0);" @click="modifyBoxFun(6)" class="btn btn-danger btn-round btn-block">
              黑名单
            </a>
          </div>
        </div>
        <div class="card" v-if="dataInfo.type==2">
          <div class="card-body">
            <p class="card-text content">注：操作后{{dataInfo.is_protect==1?'将受时效限制':'将不受时效限制'}}</p>
            <a href="javascript:void(0);" @click="submitFun(7)" class="btn btn-primary btn-round btn-block">
              <i v-if="isSubmitLoading  && type===7" class='iconfont icon-jiazai xuanzhuan'></i> {{dataInfo.is_protect==1?'取消长期':'转长期'}}
            </a>
          </div>
        </div>
      </div>
      <div class="mt-4 text-center content">
        — 共享/负责人/删除操作需要更多权限 —
      </div>
    </div>
    <div class="modifyBox" v-if="isShowStoreBox">
      <div class="boxs">
        <div class="row mainBox">

          <div class="col-12" v-if="type===1">
            <div class="row">
              <div class="col-6">
                <h3>共享人变更</h3>
              </div>
              <div class="col-6 pt-1 text-danger" v-if="info.type==='2'">
                <div class="form-check form-check-inline">
                  <input value="1" v-model="newClient" class="form-check-input" type="checkbox" id="inlineCheckbox1">
                  <label style="margin-top: -2px;" class="form-check-label" for="inlineCheckbox1">新共享人为新客分配</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
            <div class="row">
              <div class="col-3" v-for="(app,index) in shareUserArr" :key="index">
                <div class="box mb-3">
                  <div class="form-group form-check">
                    <input type="checkbox" v-model="dutyUsersVal" :value="app.id" class="form-check-input" :id="'exampleCheck'+app.id">
                    <label class="form-check-label" :for="'exampleCheck'+app.id"> {{app.name}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12" v-if="type===2">
            <div>
              <h3>负责人变更</h3>
              <hr>
            </div>
            <div class="row">
              <div class="col-4" v-for="(app,index) in userArr" :key="index">
                <div class="box mb-3">
                  <div class="form-group form-check">
                    <input type="radio" v-model="dutyUidVal" :value="app.id" class="form-check-input" :id="'exampleCheck'+app.id">
                    <label class="form-check-label" :for="'exampleCheck'+app.id"> {{app.name}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="type===3">
            <div>
              <h3>专为机会</h3>
              <hr>
            </div>
            <div class="box mb-3">
              <multiselect v-model="jihuiLevelVal" track-by="name" label="name" placeholder="机会等级" :options="jihuiLevelArr" :searchable="false"  :show-labels="false">
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
            </div>
          </div>
          <div class="col-12" v-if="type===4">
            <div class="row">
              <div class="col-12">
                <h3>转为客户</h3>
                <hr>
              </div>
              <div class="col-3 mb-3" v-for="(app,index) in userArr" :key="index">
                <div class="form-group form-check">
                  <input type="radio" v-model="dutyUidVal" :value="app.id" class="form-check-input" :id="'exampleCheck'+app.id">
                  <label class="form-check-label" :for="'exampleCheck'+app.id"> {{app.name}}</label>
                </div>
              </div>
            </div>
            <div class="box mb-3">
              <multiselect v-model="signingUserIDVal" :hideSelected="false" :options="userArr" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="客户签约人（保护字段后期不可修改） - 必选" label="name" track-by="id">
                <template slot="selection" slot-scope="{ values, search, isOpen }"></template>
              </multiselect>
            </div>
            <div class="box mb-3">
              <multiselect v-model="kehuStatusVal" track-by="name" label="name" placeholder="客户状态" :options="kehuStatusArr" :searchable="false"  :show-labels="false">
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
            </div>
            <div class="box mb-3">
              <multiselect v-model="kehuLevelVal" track-by="name" label="name" placeholder="客户等级" :options="kehuLevelArr" :searchable="false"  :show-labels="false">
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
            </div>
          </div>
          <div class="col-12" v-if="type===6">
            <div>
              <h3>申请黑名单</h3>
              <hr>
            </div>
            <div class="box tow mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">名称</span>
                </div>
                <input type="text" class="form-control" v-model="name">
              </div>
            </div>
            <div class="box mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">联系方式</span>
                </div>
                <input type="text" class="form-control" v-model="phone">
              </div>
              <p class="text-danger text-right" style="margin-top: 10px;"><i class="iconfont icon-jinggao"></i> 此时 {{phoneStr}}</p>
            </div>
            <div class="box mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">备注</span>
                </div>
                <textarea rows="2" class="form-control" v-model="content"></textarea>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="type===8">
            <div class="row">
              <div class="col-12">
                <h3>转为意向客户</h3>
                <hr>
              </div>
              <div class="col-3 mb-3" v-for="(app,index) in userArr" :key="index">
                <div class="form-group form-check">
                  <input type="radio" v-model="dutyUidVal" :value="app.id" class="form-check-input" :id="'exampleCheck'+app.id">
                  <label class="form-check-label" :for="'exampleCheck'+app.id"> {{app.name}}</label>
                </div>
              </div>
            </div>
            <div class="box mb-3">
              <multiselect v-model="yixiangStatusVal" track-by="name" label="name" placeholder="客户状态" :options="yixiangStatusArr" :searchable="false"  :show-labels="false">
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
            </div>
            <div class="box mb-3">
              <multiselect v-model="yixiangLevelVal" track-by="name" label="name" placeholder="客户等级" :options="yixiangLevelArr" :searchable="false"  :show-labels="false">
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
            </div>
          </div>
          <div class="col-12" v-if="type===9">
            <div>
              <h3>专为机会</h3>
              <hr>
            </div>
            <div class="box mb-3">
              <multiselect v-model="jihuiLevelVal" track-by="name" label="name" placeholder="机会等级" :options="jihuiLevelArr" :searchable="false"  :show-labels="false">
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
            </div>
          </div>
          <div class="col-12">
            <hr>
            <button @click="submitFun(type)" type="button" class="btn btn-success btn-round">
              &nbsp;&nbsp;&nbsp;
              <i v-if="(isSubmitLoading && type===1) || (isSubmitLoading && type===2) || (isSubmitLoading && type===3) || (isSubmitLoading && type===4) || (isSubmitLoading && type===6) || (isSubmitLoading && type===9)" class='iconfont icon-jiazai xuanzhuan'></i> 确认
              &nbsp;&nbsp;&nbsp;
            </button>
            <button @click="cancelFun" type="button" class="btn btn-light btn-round">
              &nbsp;&nbsp;&nbsp;取消
              &nbsp;&nbsp;&nbsp;
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import rbacMix from '@/util/mix/localUserMix';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { apiCrmDutylevel } from '../../../request/api';
import commons from '../../../util/commons';

export default {
  name: 'commonClientinfoShare',
  props: ['token', 'pInitDataInfo', 'info', 'rootUnitIsSuccessFun', 'isDelFun'],
  mixins: [rbacMix],
  data() {
    return {
      // 加载中
      isSearchLoading: true,
      isShowStoreBox: false,
      btnTitle: '',
      type: 1,
      dataInfo: {},
      userArr: [],
      jihuiLevelArr: [],
      yixiangLevelArr: [],
      yixiangStatusArr: [],
      kehuStatusArr: [],
      kehuLevelArr: [],
      duty_users_arr: [],
      isSubmitLoading: false,
      // 共享人组
      dutyUsersVal: [],
      // 负责人
      dutyUidVal: '',
      jihuiLevelVal: null,
      yixiangLevelVal: null,
      yixiangStatusVal: null,
      kehuStatusVal: null,
      kehuLevelVal: null,
      signingUserIDVal: null,
      name: '',
      phone: '',
      content: '',
      // 默认提示
      phoneStr: '******',
      newClient: [],
    };
  },
  computed: {
    shareUserArr() {
      return this.userArr.filter(app => app.user !== this.info.duty_uid_user);
    },
  },
  methods: {
    cancelFun() {
      this.isShowStoreBox = false;
      this.newClient = [];
    },
    modifyBoxFun(type) {
      if (type === 9 && this.info.is_del === '1' && this.info.isRbac !== 1) {
        this.$message.showMsgBox({
          type: 'warning',
          content: '创建人删除人或回收站管理员权限方可操作',
        });
      } else {
        this.dutyUsersVal = [];
        this.dutyUidVal = '';
        this.signingUserIDVal = null;
        this.jihuiLevelVal = null;
        this.yixiangLevelVal = null;
        this.yixiangStatusVal = null;
        this.kehuStatusVal = null;
        this.kehuLevelVal = null;
        this.name = '';
        this.phone = '';
        this.content = '';
        this.initData();
        this.type = type;
        this.isShowStoreBox = true;
      }
    },
    initZaizhiFun() {
      resultCommons.apiUserZaizhi(this, {}).then((ob) => {
        if (ob.state === 200) {
          this.userArr = ob.data;
        } else {
          // 请求失败
          this.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
        }
      });
    },
    initJihuiLevelFun(type, str) {
      return resultCommons.apiCrmTraceLabel(this, { type }).then((ob) => {
        if (ob.state === 200) {
          this[str] = ob.data;
        } else {
          // 请求失败
          this.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
        }
      });
    },
    initData() {
      this.dataInfo = this.info;
      // 共享人字符串
      this.duty_users_arr = (this.info.duty_users ? this.info.duty_users_str.split(',') : []).filter(app => app !== this.info.duty_uid_user);
      // this.duty_users_arr = this.info.duty_users_str.split(',');
      // 共享人id集合
      this.dutyUsersVal = this.info.duty_users ? this.info.duty_users.split(',') : [];
      // fuzer负责人
      this.dutyUidVal = this.info.duty_uid;
      // 预定义名称和联系方式
      this.name = this.info.name;
      if (this.info.phone) {
        this.phone = this.info.phone;
        this.phoneStr = '****** 默认电话';
      } else if (this.info.wechat) {
        this.phone = this.info.wechat;
        this.phoneStr = '****** 默认微信';
      } else {
        this.phone = this.info.landline;
        this.phoneStr = '****** 默认固话';
      }
    },
    submitFun(type) {
      let obj;
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      this.isSubmitLoading = true;
      this.type = type;
      // 共享
      if (type === 1) {
        obj = this.initApiCrmShare();
      }
      if (type === 2) {
        obj = this.initApiCrmDutyuid();
      }
      if (type === 3) {
        obj = this.initApiCrmSetchance();
      }
      if (type === 4) {
        obj = this.initApiCrmSetclient();
      }
      if (type === 5) {
        obj = this.initApiCrmDel();
      }
      if (type === 6) {
        obj = this.initApiCrmBlack();
      }
      if (type === 7) {
        obj = this.initApiCrmProtect();
      }
      if (type === 8) {
        obj = this.initApiCrmSetlatent();
      }
      if (type === 9) {
        obj = this.initApiCrmRecover();
      }
      if (type === 9 && this.info.is_del === '1' && this.info.isRbac !== 1) {
        this.$message.showMsgBox({
          type: 'warning',
          content: '创建人删除人或回收站管理员权限方可操作',
        });
      } else {
        // 转为机会
        obj.then((app) => {
          if (app.state === 200) {
            // 同步父级基本信息
            this.pInitDataInfo().then((app) => {
              // 同步本页面
              this.initData();
            });
            this.$message.showMsgBox({
              type: 'success',
              content: app.message,
            });
            // 编辑框
            this.isShowStoreBox = false;
            if (type === 1) {
              this.rootUnitIsSuccessFun(3, app.data.dataArrStr);
            } else if (type === 2) {
              this.rootUnitIsSuccessFun(3, app.data.dataArrStr);
            } else if (type === 3) {
              this.rootUnitIsSuccessFun(2, app.data.dataArrStr);
            } else if (type === 4) {
              this.rootUnitIsSuccessFun(2, app.data.dataArrStr);
            } else if (type === 5) {
              // 弹框UI
              this.isDelFun();
              this.rootUnitIsSuccessFun(2, app.data.dataArrStr);
            } else if (type === 6) {
              console.log(type);
            } else if (type === 7) {
              this.rootUnitIsSuccessFun(3, app.data.dataArrStr);
            } else if (type === 8) {
              this.rootUnitIsSuccessFun(2, app.data.dataArrStr);
            } else {
              this.rootUnitIsSuccessFun(2, app.data.dataArrStr);
            }
            // 处理类型
            this.type = 1;
          } else {
            this.$message.showMsgBox({
              type: 'warning',
              content: app.message,
            });
          }
          // 遮罩
          EventBus.$emit('globalZhezhaoBoxFun', false);
          // 加载中
          this.isSubmitLoading = false;
          this.newClient = [];
        });
      }
    },
    // 共享
    initApiCrmShare() {
      // 将离职的删除的隐藏掉
      const arr = [];
      this.dutyUsersVal.forEach((app) => {
        const info = this.shareUserArr.find(apps => apps.id === app);
        if (info) {
          arr.push(info.id);
        }
      });
      return resultCommons.apiCrmShare(this, { dataArrStr: this.token, duty_users: arr.join(','), newClient: this.newClient }).then(ob => ob);
    },
    // 负责人
    initApiCrmDutyuid() {
      return resultCommons.apiCrmDutyuid(this, { dataArrStr: this.token, duty_uid: this.dutyUidVal }).then(ob => ob);
    },
    // 转为机会
    initApiCrmSetchance() {
      return resultCommons.apiCrmSetchance(this, { dataArrStr: this.token, duty_level: commons.whereArrStr(this.jihuiLevelVal) }).then(ob => ob);
    },
    // 转为客户
    initApiCrmSetclient() {
      return resultCommons.apiCrmSetclient(this, {
        dataArrStr: this.token,
        duty_level: commons.whereArrStr(this.kehuLevelVal),
        duty_status: commons.whereArrStr(this.kehuStatusVal),
        duty_uid: this.dutyUidVal,
        signingUserID: commons.whereArrStr(this.signingUserIDVal),
      }).then(ob => ob);
    },
    // 删除客户
    initApiCrmDel() {
      return resultCommons.apiCrmDel(this, { dataArrStr: this.token }).then(ob => ob);
    },
    // 黑名单
    initApiCrmBlack() {
      return resultCommons.apiCrmBlackapply(this, { dataArrStr: this.token, name: this.name, phone: this.phone, content: this.content }).then(ob => ob);
    },
    // 长期客户
    initApiCrmProtect() {
      return resultCommons.apiCrmProtect(this, { dataArrStr: this.token }).then(ob => ob);
    },
    // 转为意向客户
    initApiCrmSetlatent() {
      return resultCommons.apiCrmSetlatent(this, { dataArrStr: this.token, duty_level: commons.whereArrStr(this.yixiangLevelVal), duty_status: commons.whereArrStr(this.yixiangStatusVal), duty_uid: this.dutyUidVal }).then(ob => ob);
    },
    // 捞出客户
    initApiCrmRecover() {
      return resultCommons.apiCrmRecover(this, { dataArrStr: this.token, duty_level: commons.whereArrStr(this.jihuiLevelVal) }).then(ob => ob);
    },
  },
  components: {
    Multiselect,
  },
  created() {
    this.initZaizhiFun();
    // 三个转化分类
    this.initJihuiLevelFun(4, 'jihuiLevelArr');
    this.initJihuiLevelFun(7, 'kehuStatusArr');
    this.initJihuiLevelFun(8, 'kehuLevelArr');
    this.initJihuiLevelFun(5, 'yixiangStatusArr');
    this.initJihuiLevelFun(6, 'yixiangLevelArr').then((app) => {
      this.isSearchLoading = false;
    });
  },
  mounted() {
    this.initData();
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
  .commonClientinfoShare{
    flex: 1;
    overflow-y: auto;
    background: #F6F6F6;
    padding: 15px;
    div.modifyBox{
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0,0,0,0.1);
      backdrop-filter: blur(5px);
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      div.boxs{
        background: #FFFFFF;
        padding: 15px;
        .form-group{
          margin: 0;
        }
      }
    }
    span.xiugai{
      position: absolute;
      display: inline-block;
      width: 90px;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      margin-bottom: 20px;
      text-align: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
    }
    div.showBox{
      div.card{
        margin-bottom: 15px;
        border:1px solid #DFDFDF;
        border-radius: 15px;
        .card-body{
          padding-left: 1rem;
          padding-right: 1rem;
        }
      }
      div.towBox{
        grid-template-columns: 1fr 1fr 1fr;
        display: grid;
        grid-gap: 0.7rem;
        div.card{
          margin: 0;
        }
      }
    }
    .btn.btn-round{
      padding-left: .5rem;
      padding-right: .5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/share.vue